module.exports = __webpack_public_path__ + "static/Nori-1b854b9b986951ef5cc812b6260a1fcb.jpg";